import { defineMessage } from '../../../../services/localization';

export const messages = {
    boldTitle: defineMessage('bold_ctrlcmdb'),
    italicTitle: defineMessage('italic_ctrlcmdi'),
    underlineTitle: defineMessage('underline_ctrlcmdu'),
    orderedListTitle: defineMessage('number_list_ctrlcmdshift'),
    bulletListTitle: defineMessage('bullet_list_ctrlcmdshift'),
    eraserTitle: defineMessage('clear_formatting'),
};
